import {
  WellnessMetricDto,
  WellnessCompletionRateDto,
} from '@repo/shared/dtos/analytics/WellnessDto';
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { BASE_URLS } from './config';
import { createAnalyticsHook } from './utils';

const useWellnessQuery = createAnalyticsHook({
  baseUrl: BASE_URLS.WELLNESS,
  queryKeyPrefix: 'wellness',
});

export const useWellnessMetrics = (filters?: WellnessFilter) =>
  useWellnessQuery<WellnessMetricDto>('/metrics', filters);

export const useWellnessCompletionRate = (filters?: WellnessFilter) =>
  useWellnessQuery<WellnessCompletionRateDto>('/completion-rate', filters);
